<template>
  <span>
    <div v-if="props.id_processamento === null && props.detalhes_resultado !== null">
      <span class="badge badge-primary" v-b-tooltip.hover :title="$t('Aguardando Confirmação')">
        <i class="ion ion-md-refresh"></i>
      </span>
      <span v-if="props.cancelar">({{ $i18n.t('Cancelar') }})</span>
      <span v-if="!props.cancelar">
        <span v-if="showFullResult">
          ({{ props.casa_ht }}-{{ props.fora_ht }}) / ({{ props.casa_ft }}-{{ props.fora_ft }})
        </span>
        <span v-else> ({{ props.casa_ft }}-{{ props.fora_ft }}) </span>
      </span>
    </div>

    <div v-if="props.id_processamento !== null && !props.processado && !props.cancelar_processamento">
      <span class="badge badge-stack" v-b-tooltip.hover :title="$t('Fila de Processamento')">
        <i class="ion ion-logo-buffer"></i>
      </span>
      <span v-if="props.cancelar">({{ $i18n.t('Cancelar') }})</span>
      <span v-if="!props.cancelar">
        ({{ props.casa_ht }}-{{ props.fora_ht }}) / ({{ props.casa_ft }}-{{ props.fora_ft }})
      </span>
    </div>

    <div v-if="props.processado && props.processamento_parcial">
      <span class="badge badge-warning" v-b-tooltip.hover :title="$t('Processado Parcialmente')">
        <font-awesome-icon :icon="['fa', 'cog']" />
      </span>
      <span v-if="!props.cancelar">
        ({{ props.casa_ht }}-{{ props.fora_ht }}) / ({{ props.casa_ft }}-{{ props.fora_ft }})
      </span>
    </div>

    <div v-if="props.processado && !props.processamento_parcial">
      <span class="badge badge-success" v-b-tooltip.hover :title="$t('Processado')">
        <font-awesome-icon :icon="['fa', 'check']" />
      </span>
      <span v-if="props.cancelar">({{ $i18n.t('Cancelar') }})</span>
      <span v-if="!props.cancelar">
        ({{ props.casa_ht }}-{{ props.fora_ht }}) / ({{ props.casa_ft }}-{{ props.fora_ft }})
      </span>
    </div>

    <div v-if="!props.processado && props.cancelar_processamento">
      <span class="badge badge-secondary" v-b-tooltip.hover :title="$t('Processamento Cancelado')">
        <font-awesome-icon :icon="['fa', 'times-circle']" />
      </span>
      <span v-if="props.cancelar">({{ $i18n.t('Cancelar') }})</span>
      <span v-if="!props.cancelar">
        ({{ props.casa_ht }}-{{ props.fora_ht }}) / ({{ props.casa_ft }}-{{ props.fora_ft }})
      </span>
    </div>

    <span v-if="props.id_processamento === null && props.detalhes_resultado === null">
      <span class="badge badge-danger" v-b-tooltip.hover :title="$t('Sem resultado')">
        <font-awesome-icon :icon="['fa', 'minus']" />
      </span>
    </span>
  </span>
</template>

<script>
export default {
  props: ['props'],
  computed: {
    showFullResult() {
      if (!this.props.id_tipo_esporte) return true;
      return [1, 8, 10, 29].includes(this.props.id_tipo_esporte) ? true : false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/_custom-variables.scss';
.badge-stack {
  background: $blue-dark;
  color: #fff;
}
</style>
